import React, { useEffect, useState } from 'react'

import './styles.scss'
import { botConsoleGenerativeAPI } from 'api'
import SourceItem from './SourceItem'
import ModalWrapper from 'components/ModalWrapper'
import { Button } from 'components/Form'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

const GeneratedResponsesModal = (props) => {
  const { isOpen, toggle, consoleId } = props
  const [sources, setSources] = useState([])
  const [isLoadingSources, setIsLoadingSources] = useState({})
  const [disabled, setDisabled] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    getResourcesList(consoleId)
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [])

  const getResourcesList = () => {
    setDisabled(true)
    setIsLoadingSources(prevState => ({ ...prevState, all: true }))
    botConsoleGenerativeAPI.getResourcesList({ consoleId })
      .then(({ data }) => {
        const sources = data?.length ? data : [{ _id: 1, type: 'pdf', temp: true }]
        setSources(sources)
      })
      .catch(() => setError('dashboard_sources-not-obtained'))
      .finally(() => {
        setIsLoadingSources(prevState => ({ ...prevState, all: false }))
        setDisabled(false)
      })
  }

  const handleSave = ({ sourceId, value }) => {
    if (error) setError('')

    const formData = new FormData()
    const dataBody = { consoleId }
    formData.append('data', JSON.stringify(dataBody))
    formData.append('file', value)

    setDisabled(true)
    setIsLoadingSources(prevState => ({ ...prevState, [sourceId]: true }))
    botConsoleGenerativeAPI.addResource(formData)
      .then(async ({ data }) => {
        updateSource({ sourceId, data, replace: true })
        await botConsoleGenerativeAPI.hasUpdatedResources(consoleId)
      }).catch(() => setError('dashboard_couldnt-create-source'))
      .finally(() => {
        setIsLoadingSources(prevState => ({ ...prevState, [sourceId]: false }))
        setDisabled(false)
      })
  }

  const onChangeSourceItem = ({ sourceId, values }) => {
    updateSource({ sourceId, data: values })
    if (values.value) handleSave({ sourceId, value: values.value })
  }

  const updateSource = ({ sourceId, data, replace }) => {
    if (!sourceId) return
    const updatedSources = [...sources]
    const sourceIndex = updatedSources.findIndex(({ _id }) => _id === sourceId)
    if (sourceIndex !== -1) {
      updatedSources[sourceIndex] = replace
        ? { ...data }
        : { ...updatedSources[sourceIndex], ...data }
      setSources(updatedSources)
    }
  }

  const handleRemove = sourceId => {
    const updatedSources = [...sources]
    const sourceIndex = updatedSources.findIndex(({ _id }) => _id === sourceId)
    updatedSources.splice(sourceIndex, 1)
    setSources(updatedSources)
  }

  return (
    <ModalWrapper
      id='generatedResponsesModal'
      isOpen={isOpen}
      toggle={toggle}
      header={lang('dashboard_generated-responses-sources')}
      legend={lang('dashboard_generated-responses-description')}
      body={
        <div className='generated-responses-modal__content'>
          {!isLoadingSources.all ? (
            <>
              <p className='generated-responses-modal__content-title'>{lang('dashboard_source-type')}</p>
              {sources?.length ? (
                <div className='generated-responses-modal__sources'>
                  {sources.map(source => (
                    <SourceItem
                      key={source._id}
                      consoleId={consoleId}
                      source={source}
                      loading={isLoadingSources[source._id]}
                      onChange={values => onChangeSourceItem({ sourceId: source._id, values })}
                      handleRemoveFromList={handleRemove}
                    />
                  ))}
                </div>
              ) : (
                <p className='generated-responses-modal__text-info'>
                  {lang('dashboard_no-sources-types')}
                </p>
              )}
              <Button
                clearPrimary
                className='generated-responses-modal__btn'
                icon={
                  <figure className='generated-responses-modal__btn-icon'>
                    <img
                      src={getStaticImage('/icons/orange-brand/add-circle-icon-primary.svg')}
                      alt={lang('dashboard_add-source')}
                    />
                  </figure>
                }
                value={lang('dashboard_add-source')}
                onClick={() => {
                  setSources(prevState => [
                    ...prevState,
                    { _id: prevState.length + 1, type: 'pdf', temp: true }
                  ])
                }}
              />
            </>
          ) : (
            <Nixi1Spinner width='25px' height='25px' />
          )}
        </div>
      }
      eventBtnTxt={lang('dashboard_accept')}
      eventBtn={toggle}
      contentClassName='generated-responses-modal'
      disabled={disabled}
      error={lang(error)}
    />
  )
}

export default GeneratedResponsesModal
